import React, { useState, useEffect } from "react";
import { reduxForm, Field, initialize } from "redux-form";
import { Grid, Header, Button } from "semantic-ui-react";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
const validate = (values) => {
  const errors = {};
  if (!values.srNumber) {
    errors.srNumber = "Required";
  }
  if (!values.applicationDate) {
    errors.applicationDate = "Required";
  }
  if (!values.applicationNumber) {
    errors.applicationNumber = "Required";
  }
  if (!values.applicantName) {
    errors.applicantName = "Required";
  }
  if (!values.passportNumber) {
    errors.passportNumber = "Required";
  }
  if (!values.nationality) {
    errors.nationality = "Required";
  }
  if (!values.id) {
    errors.id = "Required";
  }
  if (!values.visaType) {
    errors.visaType = "Required";
  }
  if (!values.status) {
    errors.status = "Required";
  }
  if (!values.customerName) {
    errors.customerName = "Required";
  }
  if (!values.visaCost) {
    errors.visaCost = "Required";
  }
  if (!values.invoice) {
    errors.invoice = "Required";
  }

  return errors;
};
const VisaCreation = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();

  const { id, catid } = useParams();
  const userDectail = userData();
  const [fieldDisable, setfieldDisable] = useState(false);
  const [buttonDisable, setbuttonDisable] = useState(false);
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    if (id != "null") {
      getVisaDetail();
    } else {
      const today = new Date();
      props.initialize({
        applicationDate: formatDateToYYYYMMDD(today),
      });
    }

    if (userDectail.userRole != 1 && id != "null") {
      setfieldDisable(true);
    }
  }, []);

  const getVisaDetail = () => {
    axios
      .post(BaseUrl + "listSSVisa", {
        userId: userDectail.userId,
        visaCategoryId: catid,
        getAll: catid == 0 ? true : false,
        visaTypeNumber: 1,
      })
      .then((res) => {
        console.log(res.data);
        console.log(id);
        const tempData = res.data;
        //setrowData(res.data);
        //setDataForExcel(res.data);
        const findData = tempData.find((item) => item.ssVisaId == id);
        console.log(JSON.stringify(findData, null, 2));
        initializeData(findData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const initializeData = (data) => {
    props.initialize({
      ssVisaId: data.ssVisaId,
      userId: data.userId,
      visaCategoryId: data.visaCategoryId,
      serialNumber: data.serialNumber,
      srNumber: data.srNumber,
      applicationDate: data.applicationDate,
      applicationNumber: data.applicationNumber,
      applicantName: data.applicantName,
      passportNumber: data.passportNumber,
      nationality: data.nationality,
      id: data.id,
      visaType: data.visaType,
      status: data.status,
      customerName: data.customerName,
      visaCost: data.visaCost,
      invoice: data.invoice,
      remarks: data.remarks,
      passportExpiry: data.passportExpiry,
      visaCategory: data.visaCategory,
    });
  };

  const statusVal = [
    { text: "DRAFT", value: "DRAFT" },
    { text: "POSTED", value: "POSTED" },
    { text: "TYPED", value: "TYPED" },
    { text: "READY TO PAY", value: "READY TO PAY" },
    { text: "IN PROCESS", value: "IN PROCESS" },
    { text: "APPROVED", value: "APPROVED" },
  ];

  const visaType = [
    { text: "30 DAYS SINGLE ENTRY", value: "30 DAYS SINGLE ENTRY" },
    { text: "30 DAYS SINGLE ENTRY CHILD", value: "30 DAYS SINGLE ENTRY CHILD" },
    { text: "60 DAYS SINGLE ENTRY", value: "60 DAYS SINGLE ENTRY" },
    { text: "60 DAYS SINGLE ENTRY CHILD", value: "60 DAYS SINGLE ENTRY CHILD" },
    { text: "30 DAYS MULTIPLE ENTRY", value: "30 DAYS MULTIPLE ENTRY" },
    {
      text: "30 DAYS MULTIPLE ENTRY CHILD",
      value: "30 DAYS MULTIPLE ENTRY CHILD",
    },
    { text: "60 DAYS MULTIPLE ENTRY", value: "60 DAYS MULTIPLE ENTRY" },
    {
      text: "60 DAYS MULTIPLE ENTRY CHILD",
      value: "60 DAYS MULTIPLE ENTRY CHILD",
    },
    { text: "EXTENSION", value: "EXTENSION" },
    { text: "ABSCONDING", value: "ABSCONDING" },
    { text: "CANCEL ENRTY PERMIT", value: "CANCEL ENRTY PERMIT" },
    { text: "CORRECT ENTRY PERMIT", value: "CORRECT ENTRY PERMIT" },
  ];
  const sumbitForm = (values) => {
    ///visa/createSSVisa

    const postObject = {
      ...values,
      visaCategoryId: catid,
      userId: userDectail.userId,
      visaTypeNumber: 1,
    };

    console.log(`You Values:\n\n${JSON.stringify(postObject, null, 2)}`);
    axios
      .post(BaseUrl + "/createSSVisa", postObject)
      .then((res) => {
        console.log(res.data);
        Swal.fire("Success", "Data Added", "success");
        navigate(`/list-visa-all/${res.data.visaCategoryId}`);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(values);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Visa Creation
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            {/* <Field
                name="srNumber"
                label="SR Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              /> */}

            <Grid.Column>
              <Field
                name="applicationDate"
                label="Date"
                type="date"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              {/* <Field
                name="applicationNumber"
                label="Application Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              /> */}
              <Field
                name="applicantName"
                label="Applicant Name"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="customerName"
                label="Request Person"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="passportNumber"
                label="Passport Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="passportExpiry"
                label="Passport Expiry Date"
                type="date"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="nationality"
                label="Nationality"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="visaType"
                label="Visa Type"
                type="text"
                disabled={fieldDisable === true && "true"}
                options={visaType}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="visaCost"
                label="Visa Cost"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="invoice"
                label="Invoice"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="remarks"
                label="Remarks"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="status"
                label="Status"
                options={statusVal}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="id"
                label="ID/Pan"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />
      <Button
        floated="right"
        positive
        disabled={submitting}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>{" "}
    </div>
  );
};

export default reduxForm({
  form: "VisaCreation",
  // validate,
})(VisaCreation);
